import { createSelector } from "reselect";

import { getLegCards } from "./get-leg-cards";
import {
  getSegmentsFromTripLeg,
  getSearchedLeg
} from "../../../../helpers/udm";
import { VehicleLayoutTypeKey } from "../../constants/filters";
import {
  getTrips,
  getTripsSegments,
  getVehicleLayoutTypeFilter,
  getSearch
} from "../state-accessors";

export const getFilteredLegCardIdsByVehicleLayoutType = createSelector(
  [
    getLegCards,
    getTrips,
    getTripsSegments,
    getVehicleLayoutTypeFilter,
    getSearch
  ],
  (leg_cards, trips, segments, vehicle_layout_type_filter, search) => {
    const leg_card_ids = Object.keys(leg_cards);

    if (
      !vehicle_layout_type_filter ||
      vehicle_layout_type_filter === VehicleLayoutTypeKey.All
    ) {
      return leg_card_ids;
    }

    return leg_card_ids.filter(id => {
      // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      const trip = trips[leg_cards[id][0]];
      const leg = getSearchedLeg(search, trip);
      const trip_segments = getSegmentsFromTripLeg(leg, segments);

      // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      const vehicle_type = trip_segments[0].vehicle.layout_type;

      if (vehicle_type === vehicle_layout_type_filter) {
        return true;
      }

      return false;
    });
  }
);
